import Vue from 'vue';
import http from './http_services'

const voting = {
	state: {
    unvoted_contest_list: [],
    voted_count: 0,
    force_unvoted_refresh: false
	},

  get_current_unvoted_contest_list: function() {
    return this.state.unvoted_contest_list;
  },

  get_current_force_unvoted_refresh: function(){
    return this.state.force_unvoted_refresh;
  },

  /*
  type: string; e.g. 'voted' or 'unvoted'
  */
  get_contest_list_by_type: function(instanceid, type, user_publicid) {
    let vm = this;
    // return vm.fetch_contest_list_by_type(instanceid, type, user_publicid);
    return vm.fetch_contest_list_by_type(instanceid, type, user_publicid)
      /*.then(function(response) {
        console.log('contest_list_by_type: ', response);
        vm.store_unvoted_contest_list(response.data.data);
      })*/
  },

  get_voted_count: function() {
    return this.state.voted_count;
  },

  store_voted_count: function(voted_count) {
    let vm = this;
    
    if(voted_count <= 0) {
      voted_count = 0;
    }

    vm.state.voted_count = parseInt(voted_count);
    Vue.set(vm, 'voted_count', parseInt(voted_count));
  },

  change_force_unvoted_refresh: function(new_val) {
    this.state.force_unvoted_refresh = new_val;
  },

  fetch_contest_list_by_type: function(instanceid, type, userid) {
    let vm = this;
    let requested_set = 'contest_list_by_type';
    let options = {
      instanceid: instanceid,
      type: type,
      userid: userid
    }
    
    return http.get_api_data(requested_set, options);
  },

  record_vote: function(user_publicid, instance_contestid, contest_finalistid) {
    let vm = this;
    let requested_action = 'record_vote';
    let options = {
      userid: user_publicid,
      instance_contestid: instance_contestid,
      finalistid: contest_finalistid,
      requested_action: requested_action
    }

    return http.make_simple_post(options);
  },

  store_unvoted_contest_list: function(unvoted_contest_list) {
    // this.state.unvoted_contest_list = unvoted_contest_list;
    Vue.set(this.state, 'unvoted_contest_list', unvoted_contest_list);
  }
	

}

export default voting


// WEBPACK FOOTER //
// ./src/store/modules/mod_voting.js